// styles
import './index.scss';

// project-imports
import App from './App';
import { AuthProvider } from 'context/AuthContext';
import ReactDOM from 'react-dom/client';
import { reloadOnce } from 'utils/chunkReload';

// Vite fires this when a lazy page file is missing (for example right after a release).
window.addEventListener('vite:preloadError', (event) => { event.preventDefault(); reloadOnce(); });

const root = ReactDOM.createRoot(document.getElementById('root'));


// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
    <AuthProvider>
      <App />
    </AuthProvider>
);
